import { alpha } from '@mui/material/styles';

import { grey } from '../colors';

export const muiFilledInput = {
  styleOverrides: {
    root: {
      backgroundColor: alpha(grey[600], 0.07),

      '&.Mui-focused': {
        backgroundColor: alpha(grey[600], 0.07),
      },

      '&:hover': {
        backgroundColor: alpha(grey[600], 0.1),
      },
    },
  },
};
